import stAllianzAuth from './allianzAuth.component';
import stAllianzButton from './allianzButton.component';

export default angular
  .module('st.Integrations.Allianz', ['st.Core', 'angular-cache'])
  .component('stAllianzAuth', stAllianzAuth)
  .component('stAllianzButton', stAllianzButton)
  .service('allianzService', ($http, dataService, ALLIANZ) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        ALLIANZ.API.REFER,
        { params },
        null,
        true
      )
  }))
  .constant('ALLIANZ', {
    API: {
      REFER: '/api/v1/integrations/allianz/refer'
    },
    QUESTIONS: {
      HOURS: [
        {
          option: 'Choose time',
          value: '',
          isDisabled: true
        },
        {
          option: '00:30 AM',
          value: '00:30:00'
        },
        {
          option: '01:00 AM',
          value: '01:00:00'
        },
        {
          option: '01:30 AM',
          value: '01:30:00'
        },
        {
          option: '02:00 AM',
          value: '02:00:00'
        },
        {
          option: '02:30 AM',
          value: '02:30:00'
        },
        {
          option: '03:00 AM',
          value: '03:00:00'
        },
        {
          option: '03:30 AM',
          value: '03:30:00'
        },
        {
          option: '04:00 AM',
          value: '04:00:00'
        },
        {
          option: '04:30 AM',
          value: '04:30:00'
        },
        {
          option: '05:00 AM',
          value: '05:00:00'
        },
        {
          option: '05:30 AM',
          value: '05:30:00'
        },
        {
          option: '06:00 AM',
          value: '06:00:00'
        },
        {
          option: '06:30 AM',
          value: '06:30:00'
        },
        {
          option: '07:00 AM',
          value: '07:00:00'
        },
        {
          option: '07:30 AM',
          value: '07:30:00'
        },
        {
          option: '08:00 AM',
          value: '08:00:00'
        },
        {
          option: '08:30 AM',
          value: '08:30:00'
        },
        {
          option: '09:00 AM',
          value: '09:00:00'
        },
        {
          option: '09:30 AM',
          value: '09:30:00'
        },
        {
          option: '10:00 AM',
          value: '10:00:00'
        },
        {
          option: '10:30 AM',
          value: '10:30:00'
        },
        {
          option: '11:00 AM',
          value: '11:00:00'
        },
        {
          option: '11:30 AM',
          value: '11:30:00'
        },
        {
          option: '12:00 PM',
          value: '12:00:00'
        },
        {
          option: '12:30 PM',
          value: '12:30:00'
        },
        {
          option: '01:00 PM',
          value: '13:00:00'
        },
        {
          option: '01:30 PM',
          value: '13:30:00'
        },
        {
          option: '02:00 PM',
          value: '14:00:00'
        },
        {
          option: '02:30 PM',
          value: '14:30:00'
        },
        {
          option: '03:00 PM',
          value: '15:00:00'
        },
        {
          option: '03:30 PM',
          value: '15:30:00'
        },
        {
          option: '04:00 PM',
          value: '16:00:00'
        },
        {
          option: '04:30 PM',
          value: '16:30:00'
        },
        {
          option: '05:00 PM',
          value: '17:00:00'
        },
        {
          option: '05:30 PM',
          value: '17:30:00'
        },
        {
          option: '06:00 PM',
          value: '18:00:00'
        },
        {
          option: '06:30 PM',
          value: '18:30:00'
        },
        {
          option: '07:00 PM',
          value: '19:00:00'
        },
        {
          option: '07:30 PM',
          value: '19:30:00'
        },
        {
          option: '08:00 PM',
          value: '20:00:00'
        },
        {
          option: '08:30 PM',
          value: '20:30:00'
        },
        {
          option: '09:00 PM',
          value: '21:00:00'
        },
        {
          option: '09:30 PM',
          value: '21:30:00'
        },
        {
          option: '10:00 PM',
          value: '22:00:00'
        },
        {
          option: '10:30 PM',
          value: '22:30:00'
        },
        {
          option: '11:00 PM',
          value: '23:00:00'
        },
        {
          option: '11:30 PM',
          value: '23s:30:00'
        }
      ]
    }
  });
